import { render, staticRenderFns } from "./GlobalNewslettersPage.vue?vue&type=template&id=084d2928&scoped=true&"
import script from "./GlobalNewslettersPage.vue?vue&type=script&lang=js&"
export * from "./GlobalNewslettersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084d2928",
  null
  
)

export default component.exports